module.exports = __webpack_public_path__ + "img/image_upload.9495deb8.svg";